<template>
  <div id="foot" class="foot">
    <div class="foot-wrapper">
      <div class="logo-foot">
        <img src="../assets/estate_icon/pc/logo_white@2x.png">
         <div class="foot-description">
        東京都台東区元浅草1-20-9 Estate One BLD.5F・6F <br>TEL: 03-5826-4777 FAX: 03-5826-4778
      </div>
      </div>

      <div class="foot-link">
        <div class="foot-company sp-none">
          <router-link to="/company#business" class="foot-bold">企業案内</router-link>
          <router-link to="/company#message" class="foot-thi">メッセージ</router-link>
          <router-link to="/company#summary" class="foot-thi">概要</router-link>
          <router-link to="/company#history" class="foot-thi">沿革</router-link>
          <router-link to="/company#office" class="foot-thi">オフィス風景</router-link>
          <router-link to="/company#branchoffice" class="foot-thi">支社</router-link>
        </div>
        <div class="foot-link-details">
          <router-link to="/news_list">ニュース</router-link>
          <router-link to="/team">スタッフ紹介</router-link>
          <router-link to="/gallery">物件ギャラリー</router-link>
          <router-link to="/recruit">採用情報</router-link>
          <router-link to="/contact">問い合わせ</router-link>
        </div>
      </div>
    </div>
    <div class="copyright">
        Copyright © ESTATE ONE
    </div>

  </div>
</template>

<script>
export default {
  name: 'foot',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .sp-none{
    display: flex;
    @media (max-width: 550px){
      display: none;
    }
  }
  .sp-exist{
    display: none;
    @media (max-width: 550px){
      display: flex;
    }
  }
  .foot{
    padding: 4vw 3vw;
    background-color: #000;
    background-image: url("../assets/estate_icon/foot-banner.jpg");
    position: relative;
    z-index: 1;
    .foot-wrapper{
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .logo-foot{
        width: 50vw;
        @media(max-width:550px){
          width: 90vw;
        }
      }
     .foot-description{
          color: #fff;
          font-size: 0.9vw;
          text-align: left;
          line-height: 180%;
          font-weight:500;
          letter-spacing:0.1vw;
          margin-left:3.4vw;
          margin-top:1vw;
          font-family: "SF Pro Text","Myriad Set Pro","SF Pro Icons","Apple Legacy Chevron","Helvetica Neue","Helvetica","Arial",sans-serif;
        }

      @media (max-width: 550px){
        flex-direction: column;

        .foot-description{
          color: #fff;
          font-size: 1.7vw;
          font-weight: bold;
          text-align: left;
          padding: 7vw 7vw;
          margin-left:0;
        }

      }
      .logo-foot{
        text-align: left;

        img{
          width: 17vw;
          height: auto;
        }
        @media (max-width: 550px){
          img{
            width: 35vw;
          }
        }

      }
      .foot-link{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        width: 20vw;
        margin-right: 8vw;
        margin-top: 2vw;

        a, a:visited{
          color: #fff;
          text-decoration: none;
          transition: color .3s ease;
          -webkit-transition: color .3s ease;
        }
        a:hover{
          color: #D0AF1F;
        }

        .foot-company{
          display: flex;
          flex-direction: column;
          font-size: .8vw;
          font-weight: 300;
          text-align: left;
          line-height: 1.7vw;

          .foot-bold{
            font-weight: 600;
          }
          .foot-thi{
            font-weight:0;
            font-family: "SF Pro Text","Myriad Set Pro","SF Pro Icons","Apple Legacy Chevron","Helvetica Neue","Helvetica","Arial",sans-serif;
          }
          @media (max-width: 550px){
            display: none;
          }
        }

        .foot-link-details{
          display: flex;
          flex-direction: column;
          text-align: left;
          font-size: .8vw;
          font-weight: 600;
          line-height: 2.1vw;
        }

        @media (max-width: 550px){
          width: 88vw;
          margin: auto;
          .foot-link-details{
            flex-direction: row;
            width: 100%;
            font-weight: 300;
            font-size: 1.8vw;
            padding: 3vw 0;
            a{
              margin: auto;
            }
          }
        }
      }
    }

    .copyright{
      position: relative;
      text-align: right;
      color: #6b6b6b;
      font-size: .9vw;
      padding: 1vw 0;
      //margin-right: 5vw;
      @media (max-width: 550px){
        top: -52vw;
        right: -45vw;
        font-size: 2vw;
        transform: rotate(90deg);
      }
    }
  }
</style>
